import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { MenuPath, Note, VarCard } from '../../touchpose/ui';
import { H2, Body, DocHero, DocImage, DocFooter, Steps } from './shared';
import groomBindingAddImg from '../../../assets/images/squarebit-subdivs/docs/groom-binding-add.png';
import groomSettingsImg from '../../../assets/images/squarebit-subdivs/docs/groom-settings.png';

const M = (s: string) => <MenuPath>{s}</MenuPath>;

const COMPONENT = 'Squarebit Subdiv Groom Binding';

const GroomsDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary max-w-[760px]">
      <DocHero
        title={t('subdivsDocs.layout.grooms')}
        intro={
          <Trans
            i18nKey="subdivsDocs.grooms.intro"
            components={{ comp: <>{COMPONENT}</> }}
          />
        }
        videoSrc="/videos/subdiv-groom-binding.mp4"
        videoCaption={t('subdivsDocs.grooms.videoCaption', { comp: COMPONENT })}
      />

      <Body>
        <Trans
          i18nKey="subdivsDocs.grooms.anyComponent"
          components={{ b: <strong /> }}
        />
      </Body>

      <H2 id="prereqs">{t('subdivsDocs.layout.prereqs')}</H2>
      <Note label={t('subdivsDocs.grooms.pluginsLabel')}>
        <Trans
          i18nKey="subdivsDocs.grooms.pluginsBody"
          components={{
            groom: <strong>Groom</strong>,
            agi: <strong>Alembic Groom Importer</strong>
          }}
        />
      </Note>
      <Body>{t('subdivsDocs.grooms.prereqBody')}</Body>

      <H2 id="bind">{t('subdivsDocs.layout.bind')}</H2>
      <Steps>
        <><Trans
            i18nKey="subdivsDocs.grooms.bindStep1"
            components={{
              add: M('Add'),
              gcomp: <strong>Groom Component</strong>
            }}
          /></>
        <><Trans
            i18nKey="subdivsDocs.grooms.bindStep2"
            components={{ comp: <strong>{COMPONENT}</strong> }}
          />
          <DocImage
            src={groomBindingAddImg}
            alt={t('subdivsDocs.grooms.bindAlt', { comp: COMPONENT })}
          /></>
        <>{t('subdivsDocs.grooms.bindStep3')}</>
      </Steps>

      <H2 id="behavior">{t('subdivsDocs.layout.behavior')}</H2>
      <Body>{t('subdivsDocs.grooms.behaviorBody')}</Body>

      <H2 id="settings">{t('subdivsDocs.layout.settings')}</H2>
      <DocImage
        src={groomSettingsImg}
        alt={t('subdivsDocs.grooms.settingsAlt', { comp: COMPONENT })}
      />
      <Note label={t('subdivsDocs.grooms.bindingFrameLabel')}>
        {t('subdivsDocs.grooms.bindingFrameBody')}
      </Note>
      <Body>
        <Trans
          i18nKey="subdivsDocs.grooms.rebindBody"
          components={{ b: <strong>Rebind</strong> }}
        />
      </Body>
      <VarCard name="Draw Roots" type="bool" example="false">
        {t('subdivsDocs.grooms.drawRoots')}
      </VarCard>
      <VarCard name="Bind Envelope" type="0–1" example="1">
        {t('subdivsDocs.grooms.bindEnvelope')}
      </VarCard>
      <VarCard name="Anchor to Subdivision Level" type="bool" example="false">
        {t('subdivsDocs.grooms.anchorToLevel')}
      </VarCard>

      <DocFooter current="/squarebit-subdivs/docs/grooms" />
    </article>
  );
};

export default GroomsDoc;
